import { render, staticRenderFns } from "./ResolutionMessage.vue?vue&type=template&id=4c619e66&scoped=true"
import script from "./ResolutionMessage.vue?vue&type=script&lang=ts"
export * from "./ResolutionMessage.vue?vue&type=script&lang=ts"
import style0 from "./ResolutionMessage.vue?vue&type=style&index=0&id=4c619e66&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c619e66",
  null
  
)

export default component.exports